const initInputs = (root = document) => {
  if (!root) return;
  const rootEl = typeof root === 'string' ? document.querySelector(root) : root;
  if (!rootEl) return;

  rootEl.querySelectorAll('.form-element--icon').forEach((iconInput) => {
    const icon = iconInput.querySelector('.icon');
    const input = iconInput.querySelector('input');
    if (!icon || !input) return;

    if (input.type == 'password')
      icon.addEventListener('click', () => {
        iconInput.classList.toggle('active');
        input.type = input.type == 'password' ? 'text' : 'password';
      });
  });

  rootEl.querySelectorAll('.form-element--range').forEach((rangeWrapper) => {
    const rangeMin = rangeWrapper.querySelector('input[range-min]');
    const rangeMax = rangeWrapper.querySelector('input[range-max]');
    const rangeIndicator = rangeWrapper.querySelector('.range-indicator');

    if (!rangeIndicator || !rangeMin || !rangeMax) {
      console.error('Cannot initialize range input. Essential elements missing');
      return;
    }

    const minVal = parseInt(rangeMin.min);
    const maxVal = parseInt(rangeMin.max);

    if (isNaN(minVal) || isNaN(maxVal) || minVal !== parseInt(rangeMax.min) || maxVal !== parseInt(rangeMax.max)) {
      console.error('Cannot initialize range input. Range inputs have inconsistent min/max values');
      return;
    }

    const range = maxVal - minVal;
    const gap = parseInt(rangeMin.dataset.gap || rangeMax.dataset.gap || 1);

    const updateIndicator = () => {
      const minValue = parseInt(rangeMin.value) || minVal;
      const maxValue = parseInt(rangeMax.value) || maxVal;

      let left = 0;
      let right = 0;

      if (range > 0) {
        left = ((minValue - minVal) * 100) / range;
        right = 100 - ((maxValue - minVal) * 100) / range;
      }

      rangeIndicator.style.left = `${left}%`;
      rangeIndicator.style.right = `${right}%`;
    };

    updateIndicator();

    rangeMin.addEventListener('input', () => {
      const minValue = parseInt(rangeMin.value);
      const maxValue = parseInt(rangeMax.value);

      if (minValue > maxValue - gap) {
        rangeMin.value = Math.max(minVal, maxValue - gap);
        ['input', 'change'].forEach((evt) => rangeMin.dispatchEvent(new Event(evt, { bubbles: true })));
        return; // Exit here. The newly dispatched event will trigger a clean 'updateIndicator' update
      }
      updateIndicator();
    });

    rangeMax.addEventListener('input', () => {
      const minValue = parseInt(rangeMin.value);
      const maxValue = parseInt(rangeMax.value);

      if (maxValue < minValue + gap) {
        rangeMax.value = Math.min(maxVal, minValue + gap);
        ['input', 'change'].forEach((evt) => rangeMax.dispatchEvent(new Event(evt, { bubbles: true })));
        return; // Exit here. The newly dispatched event will trigger a clean 'updateIndicator' update
      }
      updateIndicator();
    });

    // Handle 'change' event separately if needed, without triggering recursion
    [rangeMin, rangeMax].forEach((input) => {
      input.addEventListener('change', updateIndicator);
    });
  });
};

export { initInputs };
